import { type ProgramType } from 'Program';
import { type CohortSectionOffer } from 'CohortSectionOffer';
import { type PaymentSituation } from 'PaymentSituation';
import { type Nullable } from '@Types';

export enum AdmissionOfferStatus {
    OfferedAdmission = 'offered_admission',
    AcceptedAdmissionOffer = 'accepted_admission_offer',
    DeclinedAdmissionOffer = 'declined_admission_offer',
}

interface upcomingCohortDateItem {
    id: string;
    startDate: number;
}

export interface AdmissionOffer {
    id: string;
    offeredAt: number;
    cohortId: string;
    cohortName: string;
    originalCohortId?: string;
    cohortSectionOffers: CohortSectionOffer[];
    status: AdmissionOfferStatus;
    // FIXME: deprecated, remove once all UMAs are reading payment situations from CohortSectionOffers
    // See also: https://trello.com/c/oioaNcW3/769-chore-read-payment-situations-from-cohortsectionoffers-not-admissionoffers
    selectablePaymentSituations: PaymentSituation[];
    programApplicationId: string;
    programType: ProgramType;
    cohortProgramGuideUrl: string;
    eligibleThreeYearDegree: boolean;
    reportsTags: string[];
    // Replaces the label on a merit scholarship row in the tuition ledger. Serialized by
    // AdmissionOffer#as_json.
    meritLabelOverride: Nullable<string>;

    // The following properties are optional because they are only returned in an AdmissionOffer's JSON
    // when the AdmissionOffer's status is 'offered_admission'.
    // Ideally we would have a second type definition for this, similar to AssessmentBasedRefundEntitlementMetadata,
    // but that would require a hefty refactor.
    earlyRegistrationDeadline?: Nullable<number>;
    fastTrackCohortId?: Nullable<string>;
    fastTrackRegistrationDeadline?: Nullable<number>;
    fastTrackStartDate?: Nullable<number>;
    upcomingCohortDates?: upcomingCohortDateItem[];
}
